import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/imovel/';

class ImovelService {
	constructor() {
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type': 'application/json',
				'authorization': 'Bearer ' + (data ? data.token : '')
			};
		});
	}

	findImovelByFiltro(idContribuinte, filtro) {
		return axios.get(API_URL + 'allImovel?idContribuinte=' + idContribuinte + '&filtro=' + filtro, { headers: this.headers });
	}

	getImovel(id) {
		return axios.get(API_URL + id, { headers: this.headers });
	}

	saveImovel(imovel) {
		return axios.post(API_URL, JSON.stringify(imovel), { headers: this.headers });
	}

	removeImovel(id) {
		return axios.delete(API_URL + id, { headers: this.headers });
	}

	findAllByContirbuinte(filtro, idContribuinte) {
		return axios.get(API_URL + 'allByContirbuinte?idContribuinte=' + idContribuinte + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
	}
}

export default new ImovelService();